import { observer } from 'mobx-react-lite'
import { Dimensions, StyleSheet, View } from 'react-native'
import { AnimatedCircularProgress } from 'react-native-circular-progress'
import { ChipsLayout } from '../../components/ANewDesign/Board/ChipsLayout'
import { Card } from '../../components/ANewDesign/Card'
import { useStore } from '../../models'
import { color } from '../../theme'
import { DS } from '../../design-system'

const boardSize = Dimensions.get('window').height * 0.4
const EXTERNAL_BOARD_RING_PADDING = 30
export const ThreeCardBoard = observer(() => {
  const {
    game: { communityCards, mainPot, winners }
  } = useStore()

  return (
    <View>
      <AnimatedCircularProgress
        size={boardSize + EXTERNAL_BOARD_RING_PADDING}
        width={6}
        fill={0}
        rotation={0}
        tintColor={color.palette.orange}
        backgroundColor={color.palette.lightGrey}
      >
        {() => (
          <View style={styles.board}>
            <View style={styles.chipsContainer}>
              <ChipsLayout />
              <DS.Text variant="Heading 4/Regular" color="Brand/Cream">
                {mainPot ? mainPot : 'Pot'}
              </DS.Text>
            </View>
            {!winners.length ? <Card card={communityCards[0]} fontSize={24} /> : null}
          </View>
        )}
      </AnimatedCircularProgress>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  board: {
    backgroundColor: 'rgba(123, 4, 61, 1)',
    borderRadius: 400,
    height: boardSize,
    width: boardSize,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 15
  },
  chipsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10
  }
})
